/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
import React, {useState, useEffect, useRef, useCallback} from 'react';
import { useParams } from 'react-router-dom';
import FormCanvas from './FormCanvas';
import './styles.css';
import {motion} from 'framer-motion';
import AnimatedPageFade from '../../../components/Animations/AnimatedPageFade';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { dataService } from '../../../services/data.service';
import Spinner from '../../../components/Spinner';
import DocumentAuthorContext from '../../../context/DocumentAuthorContext';

function ViewForm(props) {
    const { formData, isPacketForm, packetData, pages, setPages, droppedComponents, setDroppedComponents, componentAnswers, setComponentAnswers } = props;
    const containerRef = useRef(null)
    const [view, setView] = useState(false);
    const [formType, setFormType] = useState('custom');
    const [fileType, setFileType] = useState()
    const { formID } = useParams();
    const [pdfRendered, setPdfRendered] = useState(false);
    const [fileLoading, setFileLoading] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null); useState('');
    const [pageLoading, setPageLoading] = useState(true);
    const [isModified, setIsModified] = useState(false);
    const [formSaving, setFormSaving] = useState(false);
    const [isTransforming, setIsTransforming] = useState(false);
    let currentPage = 0

    const setFormsData = async (page, isFirst) => {
        let s3Response = '';
        const payload = {
            "is_document_packet": isPacketForm,
            "form_id": formData.form_id
        }
        dataService.getSignedURLForDocuments(isPacketForm ? packetData._id : formData._id, payload).then(async (res) => {
            if(res.error === false) {
                s3Response = res.data.data;
                if(s3Response.pdf_url && formData.is_pdf_form) {
                    if(!pdfRendered) {
                        setFileType('docx');
                        setFormType('pdf');
                        let response = await dataService.getPDFBUffer(s3Response.pdf_url);
                        setSelectedFile(response.data);// Update the selected file state
                        setPdfRendered(true);
                        setPageLoading(false);
                        setFileLoading(false);
                    }
                }
                dataService.GetAllComponents(formData.form_id, page, formData.version_id).then((res1) => {
                    if(res1.error === false) {
                        const temp = {components: res1.data.data}
                        droppedComponents[page] = temp
                        setDroppedComponents([...droppedComponents])
                        setPages([...droppedComponents]);
                        setPageLoading(false);
                        setFileLoading(false);
                        setFormSaving(false);
                        setIsTransforming(false);
                        handleTransformed();
                    }
                })
            }
        })
    }

    const handleInitialFormData = async () => {
        setFormsData(currentPage, 'first');
    }

    useEffect(() => {
        handleInitialFormData();
        const body = document.getElementById('body');

        // Add a class to the element
        if (body) {
            body.classList.add('form-bg');
        }

        // Cleanup function: remove the class when the component is unmounted
        return () => {
            if (body) {
                body.classList.remove('form-bg');
            }
        };
    }, [formID]);

    const handleTransformed = () => {
        if(currentPage < formData.page_count - 1 && isTransforming === false) {
            setIsTransforming(true);
            currentPage = currentPage + 1;
            setFormsData(currentPage)
        }
    }
    return (
        <AnimatedPageFade>
            <DocumentAuthorContext.Provider value={{formType, selectedFile, setFormsData, currentPage, formData, setPdfRendered, handleInitialFormData, pages, setPages, setDroppedComponents, fileType, view, setView, pdfRendered, componentAnswers}}>
                <div className={`app bg-[#F2F2F2] ${pageLoading ? 'pointer-events-none touch-none' : ''} border border-[#797979] rounded-[12px] py-[48px] form-view mobile-form-height`}>
                    <div className={`w-full ${pageLoading ? 'h-[calc(100vh-300px)] flex items-center' : 'h-auto'} bg-[#F2F2F2]`}>
                        {pageLoading 
                            ? <Spinner />
                            :
                            <div className='mx-2'>
                                <TransformWrapper initialScale={0.6} minScale={0.6}>
                                    <TransformComponent>
                                        {pages?.map((item, index) => (
                                            <div key={index}>
                                                {formType === 'pdf' &&
                                                <>
                                                    <div className='main-canvas-container' ref={containerRef}>
                                                        {selectedFile ? (
                                                            <FormCanvas showGrid={false} isPartial={false} isModified={isModified} setIsModified={setIsModified} key={index} pageIndex={index} droppedComponents={item.components} setDroppedComponents={setDroppedComponents} /> 
                                                        )  
                                                            : <div className='h-custom-canvas flex  items-center justify-center bg-white w-[595px]'>
                                                                <p className='text-[#007EB4] font-semibold text-base'>Loading</p> 
                                                                <div>
                                                                    <Spinner width={60} height={60} />
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </>}
                                                {formType === 'custom' && 
                                                <>
                                                    <motion.div
                                                        initial={{ opacity: 0, scale: 0.8 }}
                                                        animate={{ opacity: 1, scale: 1 }}
                                                        transition={{ duration: 0.5 }} className='main-canvas-container' ref={containerRef}>
                                                        <FormCanvas showGrid={false} isPartial={false} isModified={isModified} setIsModified={setIsModified} key={index} pageIndex={index} droppedComponents={item.components} />
                                                    </motion.div>
                                                </>}
                                            </div>
                                        ))}
                                    </TransformComponent>
                                </TransformWrapper>
                                {/* </InfiniteScroll> */}
                            </div>
                       
                        }
                    </div>
                </div>  
            </DocumentAuthorContext.Provider>           
        </AnimatedPageFade>
    );
}

export default ViewForm;
